/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_H1Inputs */

const en_guide_json_rest_api_h1 = /** @type {(inputs: Guide_Json_Rest_Api_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to Use JSON in REST APIs`)
};

const ko_guide_json_rest_api_h1 = /** @type {(inputs: Guide_Json_Rest_Api_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST API에서 JSON 사용법`)
};

const ja_guide_json_rest_api_h1 = /** @type {(inputs: Guide_Json_Rest_Api_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST APIでJSONを使用する方法`)
};

/**
* | output |
* | --- |
* | "How to Use JSON in REST APIs" |
*
* @param {Guide_Json_Rest_Api_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_h1 = /** @type {((inputs?: Guide_Json_Rest_Api_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_h1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_h1(inputs)
	return ja_guide_json_rest_api_h1(inputs)
});